document.documentElement.classList.remove('no-js');

(function(){
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if(menuToggle && mobileMenu){
    menuToggle.addEventListener('click',()=>{
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
    });
  }

  document.querySelectorAll('[data-gallery]').forEach(gallery=>{
    const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
    let index=0;
    const show=(next)=>{
      if(!slides.length) return;
      index=(next+slides.length)%slides.length;
      slides.forEach((el,i)=>el.classList.toggle('is-active',i===index));
      thumbs.forEach((el,i)=>{
        el.classList.toggle('is-active',i===index);
        el.setAttribute('aria-current', i===index ? 'true' : 'false');
      });
      if(thumbs[index]) thumbs[index].scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
    };
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(index-1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(index+1));
    show(0);
  });

  document.querySelectorAll('[data-quantity]').forEach(qty=>{
    const input=qty.querySelector('[data-qty-input]');
    qty.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{
      input.value=Math.max(1,parseInt(input.value||'1',10)-1);
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
    qty.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{
      input.value=Math.max(1,parseInt(input.value||'1',10)+1);
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach(select=>{
    const section=select.closest('[data-sondell-pdp]');
    const price=section?.querySelector('[data-product-price]');
    const add=section?.querySelector('.add-to-cart');
    select.addEventListener('change',()=>{
      const opt=select.options[select.selectedIndex];
      if(price && opt?.dataset?.price) price.textContent=opt.dataset.price;
      if(add){
        const unavailable=opt.disabled;
        add.disabled=unavailable;
        const label=add.querySelector('span');
        if(label) label.textContent=unavailable ? 'Sold Out' : 'Add to Cart';
      }
    });
  });

  const sticky=document.querySelector('[data-sticky-atc]');
  const form=document.getElementById('SondellProductForm');
  if(sticky && form){
    const hero=form.closest('.product-buybox');
    const stickyBtn=sticky.querySelector('[data-sticky-submit]');
    const qty=form.querySelector('[data-qty-input]');
    const updateVisibility=()=>{
      if(!hero) return;
      const rect=hero.getBoundingClientRect();
      sticky.classList.toggle('is-visible', rect.bottom < 0);
    };
    window.addEventListener('scroll',updateVisibility,{passive:true});
    window.addEventListener('resize',updateVisibility);
    stickyBtn?.addEventListener('click',()=>form.requestSubmit());
    sticky.querySelector('[data-sticky-price]')?.replaceChildren(document.querySelector('[data-product-price]')?.cloneNode(true) || document.createTextNode(''));
    updateVisibility();
  }
})();
